import styled from 'styled-components';

const Icon = styled.i`
  display: flex;
  align-items: center;
  font-size: 18px;
`;

export default Icon;
